const API_GET_USER_PROGRAMS_FULL_REQUEST = 'API_GET_USER_PROGRAMS_FULL_REQUEST';
const API_GET_USER_PROGRAMS_FULL_SUCCESS = 'API_GET_USER_PROGRAMS_FULL_SUCCESS';
const API_GET_USER_PROGRAMS_FULL_FAILURE = 'API_GET_USER_PROGRAMS_FULL_FAILURE';

const SELECT_USER_PROGRAMS = 'SELECT_USER_PROGRAMS';
const SELECT_ROLLOUT = 'SELECT_ROLLOUT';
const SELECT_USER_MODULE = 'SELECT_USER_MODULE';
const SELECT_USER_CONTENT = 'SELECT_USER_CONTENT';
const SELECT_USER_VERSION = 'SELECT_USER_VERSION';
const SELECT_ASSESSMENT = 'SELECT_ASSESSMENT';
const SELECT_ASSESSMENT_CONTENT = 'SELECT_ASSESSMENT_CONTENT';
const SUBMIT_MCQ = 'SUBMIT_MCQ';
const TOGGLE_ASSIGNMENT_VIEW= 'TOGGLE_ASSIGNMENT_VIEW';
const TOGGLE_SPLASH_VIEW= 'TOGGLE_SPLASH_VIEW';

const SELECT_ITEM = 'SELECT_ITEM';

const TOGGLE_EXAM_COMPLETE= 'TOGGLE_EXAM_COMPLETE';

const RESET_USER_PROGRAMS = 'RESET_USER_PROGRAMS';
const RESET_SELECTED_CONTENT = 'RESET_SELECTED_CONTENT';
const SELECT_USER_ATTEMPT = 'SELECT_USER_ATTEMPT';


const SET_APPROVED = 'SET_APPROVED';
const SET_FILTER = 'SET_FILTER';

const SET_USER_RATING = 'SET_USER_RATING';
const SET_USER_RATING_COMMENT = 'SET_USER_RATING_COMMENT';
const SET_USER_RATING_VERSION = 'SET_USER_RATING_VERSION';
const RESET_USER_RATING = 'RESET_USER_RATING';
const SET_RATING_DONE = 'SET_RATING_DONE';

const SET_LOGBOOK_IMAGE = 'SET_LOGBOOK_IMAGE';
const SHOW_LONG_REGISTRATION = 'SHOW_LONG_REGISTRATION';
const SET_COST = 'SET_COST';
const SET_EXTENSIONS = 'SET_EXTENSIONS';
const SET_REFERENCE = 'SET_REFERENCE'
const SET_EXAM_TIME = 'SET_EXAM_TIME'

export const setExamTime = payload => ({
  type: SET_EXAM_TIME,
  payload,
});

export const setRatingDone = payload => ({
  type: SET_RATING_DONE,
  payload,
});


export const selectItem = payload => ({
  type: SELECT_ITEM,
  payload,
});

export const setExtensions = payload => ({
  type: SET_EXTENSIONS,
  payload,
});

export const setApproved = payload => ({
  type: SET_APPROVED,
  payload,
});
export const setReference = payload => ({
  type: SET_REFERENCE,
  payload,
});

export const toggleExamComplete = payload => ({
  type: TOGGLE_EXAM_COMPLETE,
  payload,
});

export const showLongRegistration = payload => ({
  type: SHOW_LONG_REGISTRATION,
  payload,
});

export const setLogbookImage = payload => ({
  type: SET_LOGBOOK_IMAGE,
  payload,
});
export const setFilter = payload => ({
  type: SET_FILTER,
  payload,
});

export const setUserRating = payload => ({
  type: SET_USER_RATING,
  payload,
});
export const toggleSplashView = payload => ({
  type: TOGGLE_SPLASH_VIEW,
  payload,
});
export const setUserRatingComment = payload => ({
  type: SET_USER_RATING_COMMENT,
  payload,
});
export const setUserRatingVersion = payload => ({
  type: SET_USER_RATING_VERSION,
  payload,
});
export const resetUserRating = payload => ({
  type: RESET_USER_RATING,
  payload,
});

export const selectUserVersion = payload => ({
  type: SELECT_USER_VERSION,
  payload,
});


export const resetelectedContent = () => ({
  type: RESET_SELECTED_CONTENT,
});

export const selectUserContent = payload => ({
  type: SELECT_USER_CONTENT,
  payload,
});

export const selectAssessment = payload => ({
  type: SELECT_ASSESSMENT,
  payload,
});
export const selectRollout = payload => ({
  type: SELECT_ROLLOUT,
  payload,
});
export const selectAssessmentContent = payload => ({
  type: SELECT_ASSESSMENT_CONTENT,
  payload,
});
export const submitMCQ = payload => ({
  type: SUBMIT_MCQ,
  payload,
});
export const toggleAssignmentView= payload => ({
  type: TOGGLE_ASSIGNMENT_VIEW,
  payload,
});


export const selectUserModule = payload => ({
  type: SELECT_USER_MODULE,
  payload,
});

export const resetUserPrograms = () => ({
  type: RESET_USER_PROGRAMS,
});

export const selectUserPrograms = payload => ({
  type: SELECT_USER_PROGRAMS,
  payload,
});

export const getUserProgramsFullRequest = () => ({
  type: API_GET_USER_PROGRAMS_FULL_REQUEST,
});

export const getUserProgramsFullSuccess = payload => ({
  type: API_GET_USER_PROGRAMS_FULL_SUCCESS,
  payload,
});
export const selectAttempt = payload => ({
  type: SELECT_USER_ATTEMPT,
  payload,
});

export const getUserProgramsFullFailure = payload => ({
  type: API_GET_USER_PROGRAMS_FULL_FAILURE,
  payload,
});

export const setCost = payload => ({
  type: SET_COST,
  payload,
});

const initialState = {
  selectedUserVersion: null,
  selectedContentId: null,
  selectedModuleId: null,
  selectedProgramId: null,
  selectedAssessmentId: null,
  selectedAttempt:null,
  viewAssignment:null,
  isFetched: false,
  submitMCQ:false,
  fetching: false,
  error: null,
  programs: null,
  userRating:0,
  userRatingComment:'',
  userRatingVersion:0,
  ratingDone:false,
  showSplashView:true,
  filter:['All'],
  logbookImage:null,
  showLongRegistration:false,
  assessmentContent: null,
  selectedRolloutId:null,
  requestType:null,
  approved:0,
  cost: null, 
  extensions_left:0,
  reference:null,
  examComplete: false, 
  examTimeStart:null,
  examTimeEnd:null,
  /** From Firebase exam_change; use with exam times to match user.virgil_examId */
  examTimeLibraryId: null,
  item:null
};

export function userProgramsFullReducer(state = initialState, action) {
  
  switch (action.type) {
    case SELECT_ITEM:
      return {
        ...state,
        item:action.payload
      };
    case SET_EXAM_TIME:
      return {
        ...state,
        examTimeStart: action.payload.start_time,
        examTimeEnd: action.payload.end_time,
        examTimeLibraryId:
          action.payload.library_id != null ? action.payload.library_id : state.examTimeLibraryId,
      };
    case TOGGLE_EXAM_COMPLETE:
      return {
        ...state,
        examComplete:action.payload,
      };
    case TOGGLE_SPLASH_VIEW:
      return {
        ...state,
        showSplashView:action.payload,
      };
      case SET_REFERENCE:
       
        return {
          ...state,
          reference:action.payload,
        };
      case SET_EXTENSIONS:
       
      return {
        ...state,
        extensions_left:action.payload,
      };
      case SET_COST:
      return {
        ...state,
        cost:action.payload,
      };
      case SHOW_LONG_REGISTRATION:
        return {
          ...state,
          showLongRegistration:action.payload,
        };
      case SET_LOGBOOK_IMAGE:
        return {
          ...state,
          logbookImage:action.payload,
        };
      
    case SET_FILTER:
      return {
        ...state,
        filter:action.payload,
      };
      case SELECT_ROLLOUT:
        return {
          ...state,
          selectedRolloutId:action.payload,
        };
        case SET_APPROVED:
          return {
            ...state,
            approved:action.payload,
          };
      case SET_RATING_DONE:
          return {
            ...state,
            ratingDone: action.payload,
          };
      case SET_USER_RATING_COMMENT:
         
        return {
          ...state,
          userRatingComment: action.payload,
        };
        case SET_USER_RATING_VERSION:
            
          return {
            ...state,
            userRatingVersion: action.payload,
          };
    case SET_USER_RATING:
        
      return {
        ...state,
        userRating: action.payload,
      };
      case RESET_USER_RATING:
          
        return {
          ...state,
          userRating: 0,
        };
    case RESET_SELECTED_CONTENT:
      return {
        ...state,
        selectedContentId: null,
      };
    
    case TOGGLE_ASSIGNMENT_VIEW:
      return {
        ...state,
        viewAssignment: action.payload,
      };
    case SELECT_USER_VERSION:
      return {
        ...state,
        selectedUserVersion: action.payload,
      };
      case SELECT_USER_ATTEMPT:
 
        return {
          ...state,
          selectedAttempt: action.payload,
        };
    case SELECT_USER_CONTENT:
      return {
        ...state,
        selectedContentId: action.payload,
      };
    case SELECT_ASSESSMENT:
    
      return {
        ...state,
        selectedAssessmentId: action.payload,
      };
      case SELECT_ASSESSMENT_CONTENT:
        return {
          ...state,
          assessmentContent: action.payload,
        };
      case SUBMIT_MCQ:
      
        return {
          ...state,
          submitMCQ: action.payload,
        };
    case SELECT_USER_MODULE:
      return {
        ...state,
        selectedModuleId: action.payload,
      };
    case RESET_USER_PROGRAMS:
      return {
        ...state,
        selectedProgramId: null,
        isFetched: false,
      };
    case SELECT_USER_PROGRAMS:
      
      return {
        ...state,
        selectedProgramId: action.payload,
      };
    case API_GET_USER_PROGRAMS_FULL_REQUEST:
      return {
        ...state,
        fetching: true,
      };
    case API_GET_USER_PROGRAMS_FULL_SUCCESS:
      return {
        ...state,
        isFetched: true,
        fetching: false,
        programs: action.payload.programs ? action.payload.programs : [],
      };
    case API_GET_USER_PROGRAMS_FULL_FAILURE:
      return {
        ...state,
        fetching: false,
        error: action.payload,
      };
    default:
      return state;
  }
}
